import { render, staticRenderFns } from "./StudioPage.vue?vue&type=template&id=c844e9b4&scoped=true"
import script from "./StudioPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioPage.vue?vue&type=style&index=0&id=c844e9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c844e9b4",
  null
  
)

export default component.exports